const { ensureInterestCatalog, isInterestCatalogReady } = require('services/auth-management/interest-catalog');

const internals = {
    needsCatalog: /^\/(profile|discover|messaging|classes|admin|surveys|bug-report)(\/|$)/
};

module.exports = { withInterestCatalog };

function withInterestCatalog(routes, context, fallback, parentPath = '') {

    return routes.map((route) => {

        const path = parentPath + (route.path || '');
        const next = { ...route };

        if (route.component && internals.needsCatalog.test(path)) {
            const previous = route.resolveDependencies?.$always;

            next.fallback = route.fallback || fallback;
            // Catalog consumers must not mount with an empty or previous-school list.
            next.isReadyToMount = () => isInterestCatalogReady(context);
            next.resolveDependencies = {
                ...route.resolveDependencies,
                $always: async (...args) => {

                    await ensureInterestCatalog(context);
                    return previous ? previous(...args) : undefined;
                }
            };
        }

        if (route.childRoutes) {
            next.childRoutes = withInterestCatalog(route.childRoutes, context, fallback, path);
        }

        return next;
    });
}
